// extracted by mini-css-extract-plugin
module.exports = {"modal_title":"link_toggle_modal__modal_title__1Rucm color__color_brand_base__AW2MU padding__padding_top_large__azgMZ padding__padding_left_large__q9hmW"};